import { ProductAnalyticsTrackDTO } from 'common/models/ProductAnalyticsTrackDTO';
import { trackProductAnalyticsEvent } from './api';

export async function trackEvent(dto: ProductAnalyticsTrackDTO): Promise<void> {
  try {
    await trackProductAnalyticsEvent(dto);
  } catch (error: unknown) {
    console.error('Failed to track event with API', dto, error);
  }
}
